import { ItineraryService } from 'app/shared/itinerary.service';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { ChangeDetectorRef, Component, OnInit, ViewContainerRef, Inject, PLATFORM_ID, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { Logger } from './core/logger.service';
import { I18nService } from './core/i18n.service';
import { AppService } from './app.service';
import { setting } from '../../setting';
import { UserService } from './pages/com.usblick.common/auth/user.service';
import { AuthService } from './pages/com.usblick.common/auth/auth.service';
import { AgentsService } from './agents/agents.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from './core/profiles/storeProfile';
import { selectPermissions } from './core/profiles/profiles.selectors';
import { SeoService } from 'seoService';
import { FidelityService } from './fidelity/fidelity.service';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  public loadSetting: boolean;
  public baseUrl: string;
  public apiBookingUrl: string;
  public domain: string;
  public getClientsSettingAppBooking: any;
  public cssVariableValue: string;
  public clientsSettings: any;
  public agency: any;
  namePaymentCondition: any;
  iconPaymentCondition: any;
  isAgencyPaymentCondition: boolean = false;
  balanceBlickoins: any = 0;
  creditLimits: any = 0;
  creditDeposits: any = 0;
  creditBlickoins: any = 0;
  appLoading: boolean = true;
  faviconUrl: string;

  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  private subscription: Subscription;
  private isBrowser: boolean;
  private isServer: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public vcr: ViewContainerRef,
    private titleService: Title,
    private translateService: TranslateService,
    private appService: AppService,
    public userService: UserService,
    private authService: AuthService,
    public agentsService: AgentsService,
    private _itineraryService: ItineraryService,
    private store: Store<AppState>,
    private seoService: SeoService,
    private fidelityService: FidelityService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isServer = isPlatformServer(this.platformId);
  }
  ngAfterViewInit(): void {
    this.setFavicon();
  }

  ngOnInit() {
    // Configuraciones universales (corren en servidor y cliente)
    this.initUniversalConfig();

    // Configuraciones solo para navegador
    if (this.isBrowser) {
      this.initBrowserOnly();
    }
  }

  /**
   * Configuraciones que pueden correr en servidor y cliente
   */
  private initUniversalConfig(): void {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    log.debug('init');

    // Configuración de títulos de página (no toca DOM directamente)
    const onNavigationEnd = this.router.events.filter(event => event instanceof NavigationEnd);

    Observable.merge(this.translateService.onLangChange, onNavigationEnd)
      .map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
      .filter(route => route.outlet === 'primary')
      .mergeMap(route => route.data)
      .subscribe(event => {
        const title = event['title'];
        if (title) {
          this.titleService.setTitle(this.translateService.instant(title));
        }
      });
  }

  /**
   * Configuraciones que SOLO corren en el navegador
   */
  private initBrowserOnly(): void {
    // Carga configuración del cliente
    this.loadSetting = true;
    this.getClientsSettingBooking();

    // Suscripción a actualizaciones de pago
    this.subscription = this._itineraryService.paymentUpdatebalance.subscribe(
      (paymentData) => {
        console.log('Datos de pago recibidos en app.component:', paymentData);
        this.setBalance();
      }
    );

    // Configurar scroll al navegar
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });


    this.getSubscriptionLoading();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Obtiene la configuración del cliente desde localStorage o API
   */
  async getClientsSettingBooking() {
    if (!this.isBrowser) return;

    await this.authService.getCurrenciesExchanges();
    this.getPermissions();

    // Acceso seguro a localStorage
    let clientNameStorage = null;
    try {
      const stored = localStorage.getItem(`${setting.name}`);
      clientNameStorage = stored ? JSON.parse(stored) : null;
    } catch (e) {
      console.warn('Error accessing localStorage:', e);
    }

    if (clientNameStorage) {
      const clientStorageId = clientNameStorage.id ? clientNameStorage.id : 0;
      const clientStorageUpdatedAt = clientNameStorage?.updated_at ? clientNameStorage?.updated_at : null;
      this.userService.clientIdFusion = clientNameStorage?.id;
      this.getClientApplications(clientStorageId);

      if (clientNameStorage && clientStorageId > 0 && clientStorageUpdatedAt) {
        this.clientsSettings = clientNameStorage;
        this.appService.getConsultUpdatedClient().subscribe({
          next: (res: any) => {
            if (res && res === clientStorageUpdatedAt) {
              this.loadSetting = false;
            } else {
              this.clientSubscription();
            }
          },
          error: (error: HttpErrorResponse) => {
            console.log(error);
          }
        });
      } else {
        this.clientSubscription();
      }
    } else {
      this.clientSubscription();
    }
  }

  /**
   * Suscripción para obtener configuración del cliente desde API
   */
  clientSubscription(): void {
    if (!this.isBrowser) return;

    this.appService.getClientsSettingAppBooking().subscribe({
      next: (response: any) => {
        if (response && response.id) {
          try {
            localStorage.setItem(setting.name, JSON.stringify(response));
          } catch (e) {
            console.warn('Error writing to localStorage:', e);
          }
          this.clientsSettings = response;
          this.userService.clientIdFusion = this.clientsSettings?.id;

          if (this.clientsSettings.login === 0) {
            this.appLoading = false;
          } else {
            this.getPermissions();
            this.getClientApplications(response.id);
          }
          this.loadSetting = false;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.loadSetting = false;
        console.log(error);
      }
    });
  }

  /**
   * Configura el favicon de la página
   */
  private setFavicon(): void {
    if (!this.isBrowser) return;

    try {
      const faviconUrl = this.seoService.getFaviconUrl();
      const link: HTMLLinkElement = this.document.querySelector('link[rel="icon"]') || this.document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/x-icon';
      link.href = faviconUrl;
      this.document.head.appendChild(link);
    } catch (e) {
      console.warn('Error setting favicon:', e);
    }
  }

  getSubscriptionLoading(): void {
    if (!this.isBrowser) return;

    this._itineraryService.loading$.subscribe((res: boolean) => {
      if (!res) {
        // this.appLoading = false;
      }
    });
  }

  getPermissions(): void {
    this.permissions$ = this.store.select(selectPermissions);
    this.store.dispatch({ type: '[Auth] Load Permissions' });

    this.permissions$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(permissions => {
        this.permissionsMap = this.createPermissionsMap(permissions);
        this.getAgencyData();
      });
  }

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      map[permission.name] = permission;
    });
    return map;
  }

  setBalance() {
    if (!this.isBrowser) {
      this.appLoading = false;
      return;
    }

    let pass = false;
    let creditsBlickoins = 0;
    this._itineraryService.activeItinerary
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (data: any) => {
          pass = true;
          this.agentsService.getBalanceAgency(this.userService._agencyID, this.userService._agentID)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
              next: (response: any) => {
                this.userService.creditsDeposits = parseFloat(response.balanceCreditsDeposits) ? parseFloat(response.balanceCreditsDeposits) : 0;
                this.fidelityService.creditDepositActives = this.userService.creditsDeposits;
                this.userService.credits = parseFloat(response.balanceCredits) ? parseFloat(response.balanceCredits) : 0;
                this.userService.creditLimits = this.userService.credits + this.userService.creditsDeposits;
                if (response.agent) {
                  this.userService.balanceBlickoins = parseFloat(response.agent?.availableBlickoins) ? parseFloat(response.agent?.availableBlickoins) : 0;
                  this.userService.creditBlickoins = parseFloat(response.agent?.availableCreditBlickoins) ? parseFloat(response.agent?.availableCreditBlickoins) : 0;
                } else if (!response.agent) {
                  this.setBalanceBlickoins();
                }
                this.appLoading = false;
                this.creditLimits = this.userService.creditLimits;
              },
              error: (error: HttpErrorResponse) => {
                this.appLoading = false;
                console.log(error);
              }
            });
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
          this.appLoading = false;
        }
      });
  }

  setBalanceBlickoins(): void {
    if (!this.isBrowser) {
      this.appLoading = false;
      return;
    }

    this.agentsService.getBalanceAgent(this.userService._agentID)
      .subscribe({
        next: (response: any) => {
          this.userService.balanceBlickoins = response.availableBlickoins;
          this.userService.creditBlickoins = response.availableCreditBlickoins;
          this.cdr.detectChanges();
          this.appLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
          this.appLoading = false;
        }
      });
  }

  async getAgencyData() {
    this.authService._getAgent(this.permissionsMap);
    this.authService.authInfoLoaded$
      .subscribe({
        next: (res: any) => {
          if (res) {
            if (!this.permissionsMap['booking.ingresosinagencia']) {
              this.creditLimits = this.userService.creditLimits;
              this.isAgencyPaymentCondition = false;
              this.namePaymentCondition = this._itineraryService.paymentConditionName;
              this.iconPaymentCondition = this._itineraryService.paymentConditionIcono;
              this.isAgencyPaymentCondition = true;
            }
          } else {
            this.appLoading = false;
            this.authService.profileSeller$.subscribe({
              next: (res: any) => {
                if (res) {
                  this._itineraryService.consultActiveItinerary(this.userService._agentID);
                  this.setBalance();
                  if (this.userService?.userActive && this.userService?.userActive?.pay_mode) {
                    this.setAgencyPaymentCondition(this.userService.userActive.pay_mode);
                  }
                }
              }
            });
          }
        }
      });
  }

  setAgencyPaymentCondition(pay_mode: number) {
    if (!this.isBrowser) return;

    if (pay_mode) {
      this.agentsService.agencyPaymentConditionByID(pay_mode)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (response: any) => {
            this.isAgencyPaymentCondition = false;
            if (response && typeof response === 'object' && response !== null) {
              this.namePaymentCondition = response.name;
              this.iconPaymentCondition = response.icono;
              this.agentsService.paymentConditions = response;
              this._itineraryService.paymentConditions = response;
              this.isAgencyPaymentCondition = true;
            } else {
              console.error('Invalid payment condition response:', response);
            }
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error loading payment condition:', error);
            if (this.isBrowser) {
              alert('Error al cargar condiciones de pago. Por favor, refresca la página.');
            }
          }
        });
    }
  }

  getClientApplications(clientId: any): void {
    if (!clientId) return;

    this.appService.clientsApplications(clientId).subscribe({
      next: (res: any) => {
        if (res && res.applications) {
          this.userService._clientsApplications = res.applications;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }
}
